export default __webpack_public_path__ + "static/media/Logo-Effe.1165ab94.svg";